import React, { useState } from "react";
import { InputNumber, Menu } from "antd";

import CancelButton from "../../../../components/buttons/CancelButton";
import ConfirmButton from "../../../../components/buttons/ConfirmButton";

const ToDeductModal = ({ onClose, updateUserDeduction, itemToDeduct, dataToDeduct, setDataToDeduct }) => {
  const totalStyle = () =>
    !dataToDeduct[itemToDeduct] || (dataToDeduct[itemToDeduct] && dataToDeduct[itemToDeduct].total === true)
      ? "cursor-pointer border bg-orange-500 bg-opacity-25 text-orange-500" +
        " font-bold border-orange-500 px-10 py-2 rounded-full mr-6"
      : "cursor-pointer px-10 py-2 border border-gray-600 rounded-full mr-6";
  const partialStyle = () =>
    dataToDeduct[itemToDeduct] && dataToDeduct[itemToDeduct].total === false
      ? "cursor-pointer border bg-orange-500 bg-opacity-25 text-orange-500 font-bold" +
        " border-orange-500 px-10 py-2 rounded-full"
      : "cursor-pointer px-10 py-2 border border-gray-600 rounded-full";

  return (
    <div className="divide-y">
      <div>
        <div className="flex items-center mb-10">
          <div className="font-bold mr-4">Montant :</div>
          <InputNumber
            value={(dataToDeduct[itemToDeduct] && dataToDeduct[itemToDeduct].amount) || 0}
            formatter={value => `${value} €`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            style={{ backgroundColor: "#f0f0f0", borderRadius: "11px", marginRight: "8px" }}
            min={0}
            placeholder={""}
            onChange={value =>
              setDataToDeduct({
                ...dataToDeduct,
                [itemToDeduct]: {
                  ...dataToDeduct[itemToDeduct],
                  amount: value
                }
              })
            }
          />
        </div>
        <div className="flex items-center">
          <div
            onClick={() =>
              setDataToDeduct({
                ...dataToDeduct,
                [itemToDeduct]: {
                  ...dataToDeduct[itemToDeduct],
                  total: !dataToDeduct[itemToDeduct].total
                }
              })
            }
            className={totalStyle()}
          >
            TOTAL
          </div>
          <div
            onClick={() =>
              setDataToDeduct({
                ...dataToDeduct,
                [itemToDeduct]: {
                  ...dataToDeduct[itemToDeduct],
                  total: !dataToDeduct[itemToDeduct].total
                }
              })
            }
            className={partialStyle()}
          >
            PARTIEL
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-8">
        <div className="pt-6 flex justify-center">
          <CancelButton label="Annuler" large={true} onClick={onClose} />
          <div className="ml-2">
            <ConfirmButton label={"Valider"} large={true} onClick={() => updateUserDeduction(dataToDeduct.advanced)} />
          </div>
        </div>
      </div>
    </div>
  );
};

const TransfersToDeduct = ({ onClose, updateUserDeduction, dataToDeduct, setDataToDeduct }) => {
  const [current, setCurrent] = useState("advanced");
  const getStyle = menuItemKey =>
    current === menuItemKey ? "font-bold pb-6 uppercase tracking-wide" : "pb-6 uppercase tracking-wide";

  return (
    <div>
      <Menu onClick={e => setCurrent(e.key)} selectedKeys={[current]} mode="horizontal">
        <Menu.Item key="advanced">
          <div className={getStyle("advanced")}>Avances</div>
        </Menu.Item>
        {/*<Menu.Item key="fines">*/}
        {/*  <div className={getStyle("fines")}>Amendes</div>*/}
        {/*</Menu.Item>*/}
        {/*<Menu.Item key="personalDistance">*/}
        {/*  <div className={getStyle("personalDistance")}>Kilomètres perso</div>*/}
        {/*</Menu.Item>*/}
      </Menu>
      <div className="mt-6">
        {current === "advanced" && (
          <ToDeductModal
            onClose={onClose}
            updateUserDeduction={updateUserDeduction}
            itemToDeduct="advanced"
            dataToDeduct={dataToDeduct}
            setDataToDeduct={setDataToDeduct}
          />
        )}
        {/*{current === "fines" && (*/}
        {/*  <ToDeductModal itemToDeduct="fines" dataToDeduct={dataToDeduct} setDataToDeduct={setDataToDeduct} />*/}
        {/*)}*/}
        {/*{current === "personalDistance" && (*/}
        {/*  <ToDeductModal*/}
        {/*    itemToDeduct="personalDistance"*/}
        {/*    dataToDeduct={dataToDeduct}*/}
        {/*    setDataToDeduct={setDataToDeduct}*/}
        {/*  />*/}
        {/*)}*/}
      </div>
    </div>
  );
};

export default TransfersToDeduct;



// WEBPACK FOOTER //
// src/modules/presence/transfers/transfersEmployee/TransfersToDeduct.js